// extracted by mini-css-extract-plugin
module.exports = {"paper":"main_paper__1RGWe","error":"main_error__3cys7","textRight":"main_textRight__mzNO1","flex":"main_flex__UmXf-","flexGrow":"main_flexGrow__3jeeg"};